import { connect } from "react-redux"
import React from "react"
import { deepEqual } from "utils/util"
import { GetTicket } from "node-dist/nodeDistFlag"
import _ from "lodash"
import { UserStorage } from "utils/userStorage"
import { pushSymbolList } from "node-dist/nodeDistManager"
import NodeDistClient from "node-dist/nodeDistClient"
import { config } from "config/config"
import { NODEDIST_REGIST_EXCEPTION_EXCHANGE } from "config/const"

// Number.MAX_SAFE_INTEGERを使用したいが、IE11が非対応なため（1e16は正常な演算ができる領域を超えてしまうので9e15とした）
const INITIAL_COUNT = 9e15

interface Props {
  apiSymbol: {
    SecurityType: Number
    Exchange: Number
    Symbol: String
    SymbolName?: String
  }
  renderer: Function
  push: Object
  renderIfChanged: Object
  optional?: Object
  //ひとまず銘柄詳細のレンダリング用。そのほかにもnumberで変更できるよう
  renderingId?: number
}

interface State {
  dataPush: Object
  apiSymbol: Object
  pushUpdateCount: Number
}

class PushSymbol extends React.Component<Props, State> {
  constructor(props: any) {
    super(props)
  }

  static defaultProps = {
    apiSymbol: {
      SecurityType: 0,
      Exchange: "",
      Commodity: 0,
      Symbol: "",
      SymbolName: "",
    },
  }

  state: Readonly<State> = {
    dataPush: {},
    apiSymbol: {},
    pushUpdateCount: INITIAL_COUNT,
  }

  componentDidMount() {
    pushSymbolList()
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    if (!deepEqual(prevState.dataPush, this.state.dataPush)) {
      pushSymbolList()
    }
  }

  componentWillUnmount() {
    pushSymbolList()
  }

  static getDerivedStateFromProps(nextProps: any, prevState: any) {
    if (
      nextProps.apiSymbol.SecurityType !== prevState.apiSymbol.SecurityType ||
      nextProps.apiSymbol.Exchange !== prevState.apiSymbol.Exchange ||
      nextProps.apiSymbol.Commodity !== prevState.apiSymbol.Commodity ||
      nextProps.apiSymbol.Symbol !== prevState.apiSymbol.Symbol ||
      nextProps.apiSymbol.SymbolName !== prevState.apiSymbol.SymbolName ||
      nextProps.pausePush !== prevState.pausePush
    ) {
      const { apiSymbol, pausePush } = nextProps
      return {
        pausePush: nextProps.pausePush,
        apiSymbol: nextProps.apiSymbol,
        dataPush:
          !_.isEmpty(apiSymbol) &&
          apiSymbol.Symbol &&
          apiSymbol.SecurityType !== undefined &&
          apiSymbol.Exchange !== undefined &&
          !_.includes(NODEDIST_REGIST_EXCEPTION_EXCHANGE, apiSymbol.Exchange)
            ? {
                "data-symbol": GetTicket(
                  apiSymbol.SecurityType,
                  apiSymbol.Symbol,
                  apiSymbol.Exchange,
                  "MarketInfoFull"
                ),
                "data-push": !pausePush,
              }
            : {},
      }
    }

    if (!deepEqual(nextProps.renderIfChanged, prevState.renderIfChanged)) {
      return {
        renderIfChanged: nextProps.renderIfChanged,
        pushUpdateCount:
          prevState.pushUpdateCount === 0
            ? INITIAL_COUNT
            : prevState.pushUpdateCount - 1,
      }
    }

    return null
  }

  shouldComponentUpdate(nextProps: any, nextState: any) {
    if (
      !deepEqual(nextProps.push, this.props.push) ||
      !deepEqual(nextState.dataPush, this.state.dataPush) ||
      //rendererの中身がapiSymbol, pausePush, push以外のpropsによって再リンダーされますのでその他propsを親から明示的に渡してもらう。
      this.state.pushUpdateCount !== nextState.pushUpdateCount ||
      this.props.renderingId !== nextProps.renderingId
    ) {
      return true
    } else return false
  }

  render() {
    const { renderer, apiSymbol, push, renderIfChanged, optional } = this.props
    return (
      <>
        {renderer(
          push === undefined ? {} : push,
          apiSymbol,
          this.state.dataPush,
          renderIfChanged,
          optional === undefined ? {} : optional
        )}
      </>
    )
  }
}

export default connect(
  (state: any, props: any) => {
    return {
      push: state.push[props.ticketKey],
      pausePush: state.push.pausePush,
    }
  },
  null,
  null,
  {
    forwardRef: true,
  }
)(PushSymbol as any)
